import React from "react";
import { Row } from "react-bootstrap";
import "../../assets/styles/grid-menu.scss";
import { routesAdmin } from "../../router";
import GridItem from "./parts/GridItem";

const GridMenu = () => {
  const menuItems = routesAdmin.filter((r) => r.isMenu);

  return (
    <Row className="grid-menu">
      {menuItems.map((route) => (
        <GridItem key={route.id} route={route} />
      ))}
    </Row>
  );
};

export default GridMenu;
